<mat-divider></mat-divider>

<div class="applied-filters">
  <applied-filters [filters]="appliedFilters" (onFilterRemoved)="onFilterRemoved($event)"/>
</div>

<h3 i18n style="margin-left: 16px" class="mat-heading-6">Shop by category</h3>

<div class="tree">
  <ng-container *ngFor="let node of categoryTree">
    <div class="level1"><a
          (click)="searchForCategory(node.code)"
          [ngClass]="hasSubCategories() ? 'mat-subtitle-2' : 'mat-caption'"
          angulartics2On="click"
          angularticsAction="Link Pressed"
          angularticsCategory="Category filter"
          [angularticsLabel]="node.name">{{ node.name }}</a>
    </div>
    <ng-container *ngFor="let child of node.children">
      <div class="level2">
          <a
              (click)="searchForCategory(child.code)"
              class="mat-caption"
              angulartics2On="click" 
              angularticsAction="Link Pressed"
              angularticsCategory="Category filter"
              [angularticsLabel]="child.name">{{ child.name }}</a>
      </div>
    </ng-container>
  </ng-container>
</div>

<mat-divider></mat-divider>

<h3 i18n style="margin-left: 16px; margin-top: 8px;" class="mat-heading-6">Dispatched from</h3>

<div class="tree">
  <div class="level1"><a
      (click)="searchByDispatchedFrom()"
      ngClass="mat-caption"
      angulartics2On="click"
      angularticsAction="Link Pressed"
      angularticsCategory="Dispatched from filter"
      angularticsLabel="Listx warehouse"
      i18n>Listx warehouse</a>
  </div>
</div>